<div class="w-full h-full flex items-center justify-center">
    <h1 class="text-white">You are not authorized to view this page.</h1>
</div>
